
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";

interface District {
  name: string;
}

interface PartnerAreaDelivery {
  cityCode: string;
  cityName: string;
  districts: District[];
}

interface DetailData {
  partnerAreaDeliveries: PartnerAreaDelivery[];
}

class Props {
  detailData = prop<any>({
    type: Object,
    required: true
  });
}

@Options({
  components: {
    Title
  }
})
export default class DetailPosOwnedList extends Vue.with(Props) {
  public isShowDistrictDialog = false;
  public dialogTitle = "";
  public dialogDistricts = "";

  public openDistrictDialog(index: number): void {
  const item = this.detailData?.posOwnedList?.[index];

  if (item) {
    this.dialogTitle = `${item.cityCode || "-"} - ${item.cityName || "-"}`;
    this.dialogDistricts = item.districtName || '';
    this.isShowDistrictDialog = true;
  }
}



  public closeDistrictDialog(): void {
    this.isShowDistrictDialog = false;
    this.dialogTitle = "";
    this.dialogDistricts = "";
  }
}
